import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function Stats({ convertCount, copyCount }) {
  const statsData = [
    {
      title: 'จำนวนที่แปลงแล้ว',
      value: convertCount,
      icon: <TrendingUpIcon />,
      color: 'primary',
    },
    {
      title: 'จำนวนที่คัดลอกแล้ว',
      value: copyCount,
      icon: <ContentCopyIcon />,
      color: 'secondary',
    },
  ];

  return (
    <Grid container spacing={3}>
      {statsData.map((stat, index) => (
        <Grid item xs={12} sm={6} key={stat.title}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%)',
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
              border: '2px solid #ffc425',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: -50,
                right: -50,
                width: 200,
                height: 200,
                borderRadius: '50%',
                background: stat.color === 'primary' 
                  ? 'radial-gradient(circle, rgba(0, 60, 113, 0.1) 0%, transparent 70%)'
                  : 'radial-gradient(circle, rgba(255, 196, 37, 0.1) 0%, transparent 70%)',
              },
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 32px rgba(0, 60, 113, 0.2)',
                borderColor: '#003c71',
                transition: 'all 0.3s ease',
              },
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 700,
                      color: stat.color === 'primary' ? 'primary.main' : 'secondary.dark',
                    }}
                  >
                    {stat.value.toLocaleString()}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                      fontWeight: 500,
                      mt: 1,
                    }}
                  >
                    {stat.title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: '50%',
                    bgcolor: stat.color === 'primary' 
                      ? 'primary.light' 
                      : 'secondary.light',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0.9,
                  }}
                >
                  {stat.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default React.memo(Stats);
